import { createContext, FC, ReactNode, useContext, useState } from 'react';

import { IDialContext, DialOptions, defaultState } from './types';

export const DialContext = createContext<IDialContext | undefined>(undefined);

export const AccountDialProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const [dialContentState, setDialContent] = useState<{ [index in DialOptions]: boolean }>(defaultState);
  const [activeDialContent, setActiveDialContent] = useState<DialOptions | undefined>();
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);
  const [dialOpen, setDialOpen] = useState<boolean>(false);
  const [isLifiWidgetOpen, setIsLifiWidgetOpen] = useState<boolean>(false);

  function resetAll() {
    setActiveDialContent(undefined);
    setDialContent(defaultState);
    setIsFullscreen(false);
  }

  function switchDialContent(option: DialOptions) {
    setDialContent(oldContent => ({ ...defaultState, [option]: !oldContent[option] }));
    setActiveDialContent(option);
  }

  return (
    <DialContext.Provider
      value={{
        resetAll,
        switchDialContent,
        dialContentState,
        activeDialContent,
        isFullscreen,
        setIsFullscreen,
        dialOpen,
        setDialOpen,
        isLifiWidgetOpen,
        setIsLifiWidgetOpen,
      }}
    >
      {children}
    </DialContext.Provider>
  );
};

export const useAccountDial = () => {
  const dialContext = useContext(DialContext);

  if (!dialContext) throw 'Please wrap account dial in its provider...';

  return dialContext;
};
